/**
 * The IIFE entry: find our own script tag and mount an empty widget root.
 *
 * `document.currentScript` is read **synchronously at module evaluation** and
 * stashed. With `defer` it is still correct, and it is the only reliable way to
 * find our own tag when a page has several — scanning for
 * `script[src*="widget.js"]` breaks the first time a hotel inlines or proxies
 * the bundle.
 */
import { h, render } from 'preact';

const script = document.currentScript as HTMLScriptElement | null;

function boot(): void {
  if (!script) {
    console.error('[meltemi] widget.js must be loaded from a <script> tag');
    return;
  }
  if (script.dataset.melMounted !== undefined) return;
  script.dataset.melMounted = '';

  const host = document.createElement('div');
  script.after(host);
  const shadow = host.attachShadow({ mode: 'open' });
  const root = document.createElement('div');
  root.className = 'mel-root';
  shadow.append(root);
  render(h('div', null), root);
}

// `defer` (and any module script) runs after parsing, so the insertion point is
// already there. A plain synchronous tag in <head> is not, hence the wait.
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot, { once: true });
} else {
  boot();
}
